import { render, staticRenderFns } from "./DottoriList.vue?vue&type=template&id=2ca41690&"
import script from "./DottoriList.vue?vue&type=script&lang=ts&"
export * from "./DottoriList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports